import _ from 'lodash';
import { QUOTED, START } from 'shared/data/quoteSteps';

const state = {
  quoteStep: START,
  parameters: {
    carrier_thickness: '6 mm',
  },
};

if (Spree.variant_id) {
  state.variantId = Spree.variant_id;
}

if (Spree.initial_cart_data) {
  state.quantity = _.get(Spree.initial_cart_data, 'quantity', 1);
}

if (Spree.quote) {
  state.quoteStep = QUOTED;
  state.quote = Spree.quote;
}

if (Spree.quote_parameters) {
  state.parameters = _.merge({}, state.parameters, Spree.quote_parameters);
}

export default state;
